import { Action, Reducer } from "redux";
import { QuoteStatusState, QuoteStatusTypes, QuoteStatusActionTypes } from "./quoteStatusTypes";

export const INITIAL_STATE: QuoteStatusState = {
	quoteStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const quoteStatusReducer: Reducer<QuoteStatusState> = (state: QuoteStatusState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as QuoteStatusActionTypes;
	switch (actionTypes.type) {
		case QuoteStatusTypes.GET_QUOTE_STATUS:
			return {
				...state,
				quoteStatus: { ...state.quoteStatus, isLoading: true },
			};
		case QuoteStatusTypes.SAVE_QUOTE_STATUS:
			return {
				...state,
				quoteStatus: {
					...state.quoteStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case QuoteStatusTypes.RESET_REDUCER_QUOTE_STATUS:
			return {
				...state,
				quoteStatus: INITIAL_STATE.quoteStatus,
			};
		case QuoteStatusTypes.GET_DOMAIN_QUOTE_STATUS:
			return {
				...state,
				quoteStatus: { ...state.quoteStatus, isLoading: true },
			};
		default:
			return state;
	}
};

export default quoteStatusReducer;
